import { render, staticRenderFns } from "./AssetsDataTable.vue?vue&type=template&id=cb607f6c&scoped=true&"
import script from "./AssetsDataTable.vue?vue&type=script&lang=ts&"
export * from "./AssetsDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./AssetsDataTable.vue?vue&type=style&index=0&id=cb607f6c&scoped=true&lang=scss&"
import style1 from "./AssetsDataTable.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./AssetsDataTable.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb607f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
